import { FC } from 'react';
import { ButtonProps } from '../button.component';
import { CoreButton } from '../../_core';
import { clsx, useStyles } from '../../../utils';
import { rainbowButtonStyles } from './rainbow-button.styles';

export interface RainbowButtonProps extends ButtonProps {
	disableShadow?: boolean;
}

export const RainbowButton: FC<RainbowButtonProps> = ({ disableShadow, ...props }) => {
	const styles = useStyles(rainbowButtonStyles, disableShadow);

	return (
		<CoreButton {...props} sx={clsx(styles.button, props.sx)}>
			{props.children}
		</CoreButton>
	);
};
